import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom'

import SubscriptionManagement from './SubscriptionManagement'
import SubscriptionHistory from './SubscriptionHistory'
import {
  SUBSCRIPTION_MANAGE_ROUTE,
  SUBSCRIPTION_RENEWALS_ROUTE,
  SUBSCRIPTION_UPDATE_ROUTE,
  SUBSCRIPTION_DETAILS_ROUTE,
} from './consts'
import SubscriptionUpdate from './SubscriptionUpdate'
import SubscriptionDetails from './SubscriptionDetails'
import SubscriptionRenewals from './SubscriptionRenewals'

function HomeSubscription() {
  const { path, url } = useRouteMatch()

  return (
    <>
      <Switch>
        <Route exact path={`${path}/`} component={SubscriptionHistory} />
        <Route path={`${path}/${SUBSCRIPTION_MANAGE_ROUTE}`}>
          <SubscriptionManagement />
        </Route>
        <Route path={`${path}/${SUBSCRIPTION_UPDATE_ROUTE}`}>
          <SubscriptionUpdate />
        </Route>
        <Route path={`${path}/${SUBSCRIPTION_DETAILS_ROUTE}`}>
          <SubscriptionDetails />
        </Route>
        <Route path={`${path}/${SUBSCRIPTION_RENEWALS_ROUTE}`}>
          <SubscriptionRenewals />
        </Route>
        <Route path="*">
          <Redirect to={url} />
        </Route>
      </Switch>
    </>
  )
}

export default HomeSubscription
